export const authInitialState = {
    currentUser: null,
    isLoading: true,
};
